import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { token } from "../Actions/AuthAction";
import { uploadCandidateOfferLetter } from "../Actions/EmployerAction";
import { roleid } from "../Actions/AuthAction";
import CONFIG from "../../config";

export const CandidateProfile = (props) => {
  const [candidateDetails, setCandidateDetails] = useState(
    props.candidateDetails
  );
  const [showPdfSubmit, setShowPdfSubmit] = useState(false);
  console.log(candidateDetails);
  const sampleImage = "../../assets/img/profile128.png";
  const uploadOfferLetter = (values) => {
    values.preventDefault();

    const reader = new FileReader();
    reader.readAsDataURL(showPdfSubmit);
    reader.onload = (data) => {
      let json = JSON.stringify(reader.result);

      let str1 = "";
      json.split("/").map((item, index) => {
        if (index != 0) {
          if (index == json.split("/").length - 1) {
            str1 += item;
          } else {
            str1 += item + "/";
          }
        }
      });
      const jsonToPost = {
        key: token(),
        emp_id: candidateDetails.employer_id,
        candidate_id: candidateDetails.candidate_id,
        offer_letter: "data:@file/" + str1,
        job_id: candidateDetails.job_id,
      };

      uploadCandidateOfferLetter(jsonToPost).then((res) => {
        if (res.status) {
          Swal.fire("Offer Letter Uploaded Successfully", "", "success");
          window.location.reload();
        } else {
          Swal.fire("OOPS Something went wrong", "", "warning");
        }
        console.log(res);
      });

      setShowPdfSubmit(false);
    };
  };
  return (
    <React.Fragment>
      <div className="container-fluid my-1">
        <div className="row">
          <div className="col-md-3 col-sm-12 col-xs-12">
            <div className=" profilebox mt-5 pt-5">
              {candidateDetails.candidateconditional &&
                candidateDetails.candidateconditional.profilepic ? (
                <img
                  src={`${CONFIG.IMAGE_URL}/${candidateDetails.candidateconditional.profilepic}`}
                  alt="Image not available"
                  className="profileimg shadow"
                />
              ) : (
                <img
                  src={sampleImage}
                  alt="Image not available"
                  className="profileimg shadow"
                />
              )}
              <h2>
                {candidateDetails.candidateconditional.firstname}{" "}
                {candidateDetails.candidateconditional.middlename}{" "}
                {candidateDetails.candidateconditional.lastname}
              </h2>
              <p className="title">
                {candidateDetails.candidateconditional.inst.name}
              </p>
              <p>
                ({candidateDetails.candidateconditional.uni.university_name})
              </p>
              <Link
                className="btn btn-secondary-custom mx-2 mb-2"
                to={`/profile/${candidateDetails.candidate_id}`}
              >
                View Profile
              </Link>
            </div>
          </div>
          <div className="col-md-9 col-sm-12 col-xs-12">
            <div className="card rightside">
              <div id="myTabs">
                <ul className="nav nav-tabs profiletabnew" role="tablist">
                  <li role="presentation">
                    <a
                      href="#home"
                      aria-controls="home"
                      role="tab"
                      data-toggle="tab"
                      className="active"
                    >
                      Candidate Details
                    </a>
                  </li>
                  <li role="presentation">
                    <a
                      href="#profile"
                      aria-controls="profile"
                      role="tab"
                      data-toggle="tab"
                    >
                      Applied Details
                    </a>
                  </li>
                  {props.notShowOfferLetter ? null : (
                    <li role="presentation">
                      <a
                        href="#services"
                        aria-controls="services"
                        role="tab"
                        data-toggle="tab"
                      >
                        Offer Letter Details
                      </a>
                    </li>
                  )}
                </ul>

                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active py-3"
                    id="home"
                  >
                    <div className="card-header1 ml4">Personal Details</div>
                    <div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <tbody>
                            <tr>
                              <th scope="row">Roll Number</th>
                              <td>:</td>
                              <td>
                                {
                                  candidateDetails.candidateconditional
                                    .rollnumber
                                }
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Date Of Birth</th>
                              <td>:</td>
                              <td>
                                {
                                  candidateDetails.candidateconditional.dob.split(
                                    " "
                                  )[0]
                                }
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Mobile Number</th>
                              <td>:</td>
                              <td>
                                {
                                  candidateDetails.candidateconditional.user
                                    .phone
                                }
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Email</th>
                              <td>:</td>
                              <td>
                                {
                                  candidateDetails.candidateconditional.user
                                    .email
                                }
                              </td>
                            </tr>
                            {candidateDetails.candidateconditional
                              .alternatenumber && (
                                <tr>
                                  <th scope="row">Alternate Number</th>
                                  <td>:</td>
                                  <td>
                                    {
                                      candidateDetails.candidateconditional
                                        .alternatenumber
                                    }
                                  </td>
                                </tr>
                              )}
                            <tr>
                              <th scope="row">Description</th>
                              <td>:</td>
                              <td>
                                {
                                  candidateDetails.candidateconditional
                                    .description
                                }
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Fathers Name</th>
                              <td>:</td>
                              <td>
                                {
                                  candidateDetails.candidateconditional
                                    .fathersname
                                }
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Gender</th>
                              <td>:</td>
                              <td>
                                {candidateDetails.candidateconditional.gender ==
                                  1
                                  ? "Male"
                                  : candidateDetails.candidateconditional
                                    .gender == 2
                                    ? "Female"
                                    : candidateDetails.candidateconditional
                                      .gender == 3
                                      ? "Other"
                                      : null}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div role="tabpanel" className="tab-pane py-3" id="profile">
                    <div>
                      <div className="card-header1 ml4">Employer Details</div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <tbody>
                            <tr>
                              <th scope="row">Company Name</th>
                              <td>:</td>
                              <td>{candidateDetails.employer.companyname}</td>
                            </tr>
                            <tr>
                              <th scope="row">Website</th>
                              <td>:</td>
                              <td>
                                <a
                                  href={
                                    candidateDetails.employer.companywebsite
                                  }
                                  target="_blank"
                                >
                                  {candidateDetails.employer.companywebsite}
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">About</th>
                              <td>:</td>

                              <td
                                className="border-0"
                                dangerouslySetInnerHTML={{
                                  __html: candidateDetails.employer.about,
                                }}
                              />
                            </tr>
                            <tr>
                              <th scope="row">Representative Name</th>
                              <td>:</td>
                              <td>{candidateDetails.employer.spocname}</td>
                            </tr>
                            <tr>
                              <th scope="row">Representative Number</th>
                              <td>:</td>
                              <td>{candidateDetails.employer.spocphoneno}</td>
                            </tr>
                            <tr>
                              <th scope="row">Representative Email</th>
                              <td>:</td>
                              <td>{candidateDetails.employer.spocemail}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="card-header1 ml4">Drive Details</div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <tbody>
                            <tr>
                              <th scope="row">Drive Id</th>
                              <td>:</td>
                              <td>
                                #{candidateDetails.drive.driveid}{" "}
                                {candidateDetails.drive.drivestatus == 2 ? (
                                  <span className="badge badge-pill badge-success mx-1 p-1 my-1">
                                    Open
                                  </span>
                                ) : (
                                  <span className="badge badge-pill badge-danger mx-1 p-1 my-1">
                                    Closed
                                  </span>
                                )}
                                {candidateDetails.drive.drivetype == 1 ? (
                                  <span className="badge badge-pill badge-warning mx-1 p-1 my-1">
                                    Single
                                  </span>
                                ) : (
                                  <span className="badge badge-pill badge-dark mx-1 p-1 my-1">
                                    Pool
                                  </span>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Selection Process</th>
                              <td>:</td>
                              <td
                                className="border-0"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    candidateDetails.drive.selectionprocess,
                                }}
                              />
                            </tr>
                            <tr>
                              <th scope="row">Drive Venue Status</th>
                              <td>:</td>
                              <td>{candidateDetails.drive.driveid}</td>
                            </tr>
                            <tr>
                              <th scope="row">Drive Venue</th>
                              <td>:</td>
                              <td
                                className="border-0"
                                dangerouslySetInnerHTML={{
                                  __html: candidateDetails.drive.venue,
                                }}
                              />
                            </tr>
                            <tr>
                              <th scope="row">Drive Start Date</th>
                              <td>:</td>
                              <td>{candidateDetails.drive.drivestartdate}</td>
                            </tr>
                            <tr>
                              <th scope="row">Drive End Date</th>
                              <td>:</td>
                              <td>{candidateDetails.drive.driveenddate}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="card-header1 ml4">Job Details</div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <tbody>
                            <tr>
                              <th scope="row">Job Id</th>
                              <td>:</td>
                              <td>{candidateDetails.job.jobid}</td>
                            </tr>
                            <tr>
                              <th scope="row">Job Designation</th>
                              <td>:</td>
                              <td>{candidateDetails.job.jobdesignation}</td>
                            </tr>
                            <tr>
                              <Link
                                to={`/jobdetail/${candidateDetails.job.jobid}`}
                              >
                                View More
                              </Link>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div role="tabpanel" className="tab-pane py-3" id="services">
                    <div>
                      <div className="card-header1 ml4">Letter Details</div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <tbody>
                            <tr>
                              <th scope="row">Offer Letter</th>
                              <td>:</td>
                              <td>
                                {candidateDetails &&
                                  candidateDetails.candidateofferletters ==
                                  null ? (
                                  "-"
                                ) : (
                                  <>
                                    (
                                    <a
                                      href={`${CONFIG.IMAGE_URL}/${candidateDetails.candidateofferletters.offerletterdetails}`}
                                      target="_blank"
                                    >
                                      View
                                    </a>
                                    ) | (
                                    <a
                                      href={`${CONFIG.IMAGE_URL}/${candidateDetails.candidateofferletters.offerletterdetails}`}
                                      download
                                    >
                                      Download
                                    </a>
                                    )
                                    <div>
                                      {
                                        candidateDetails.candidateofferletters
                                          .updatedat
                                      }
                                    </div>
                                  </>
                                )}
                                {roleid() == 4 ? (
                                  <form onSubmit={uploadOfferLetter}>
                                    <label
                                      className="small mb-1 btn btn-primary"
                                      for="offerLetter"
                                    >
                                      {showPdfSubmit
                                        ? "Replace Offer Letter"
                                        : " Upload Offer Letter"}
                                    </label>

                                    <input
                                      type="file"
                                      hidden
                                      accept=".pdf,.doc,.docx"
                                      id="offerLetter"
                                      onChange={(e) => {
                                        setShowPdfSubmit(e.target.files[0]);
                                      }}
                                    ></input>
                                    {showPdfSubmit ? (
                                      <button
                                        type="submit"
                                        className="small mb-1 btn btn-success ml-2 "
                                      >
                                        Submit
                                      </button>
                                    ) : null}
                                  </form>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
